"use client";

import { forwardRef } from "react";
import { BlokParameters } from "../blokSetup/blok-component-types";
import { getBlokComponent } from "../blokSetup/bloks";
import { StoryblokComponentProps } from "./StoryblokComponent";
import ClientComponentNoSSR from "./ClientComponent/ClientComponentNoSSR";
import ClientComponentWithFetcherNoSSR from "./ClientComponentWithFetcher/ClientComponentWithFetcherNoSSR";

const ClientStoryblokComponent = forwardRef<
  HTMLElement,
  StoryblokComponentProps<BlokParameters>
>(({ blok, preview = false, sidebyside, articles, ...restProps }, ref) => {
  if (!blok) {
    const errorMessage = "Please provide a blok";
    console.error(errorMessage);
    return <div>{errorMessage}</div>;
  }

  if (!blok.component) {
    const errorMessage = `Component is not listed in bloks`;
    console.error(errorMessage);
    return <div>{errorMessage}</div>;
  }

  const component = getBlokComponent(blok.component);

  if (component && typeof component === "object" && "fetcher" in component) {
    return (
      <ClientComponentWithFetcherNoSSR
        key={blok.component}
        blok={blok}
        preview={preview}
        ref={ref}
        {...restProps}
        sidebyside={sidebyside}
        articles={articles}
        fetcher={component.fetcher}
      />
    );
  }

  return (
    <ClientComponentNoSSR
      key={blok.component}
      blok={blok}
      preview={preview}
      sidebyside={sidebyside}
      articles={articles}
      {...restProps}
      ref={ref}
    />
  );
});

ClientStoryblokComponent.displayName = "ClientStoryblokComponent";

export default ClientStoryblokComponent;
